import axios from 'axios';
import { get } from 'lodash-es';
import { setAuthStateAsIntiital } from '../store';
import doLogout from '../utils/auth/logout';
// import { useHistory } from 'react-router-dom';
import Cookies from 'universal-cookie';
import getbackendUrl from './getBackendUrl';
import getFreshTokens from './getFreshToken';
const cookies = new Cookies();
const myAxios = axios.create({
  baseURL: getbackendUrl(),
  withCredentials: true,
});

myAxios.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    // const history = useHistory();
    const statusCode = get(error, 'response.status');

    if (statusCode === 401) {
      // Logout if 401 is received
      doLogout();
      setAuthStateAsIntiital();
      // history.push('/auth/login');
    }

    return Promise.reject(error);
  },
);

myAxios.interceptors.request.use(async (config) => {
  const idToken = cookies.get('jp_idtoken');
  const refreshToken = cookies.get('jp_refreshtoken');

  const accessToken = await getFreshTokens(idToken, refreshToken);

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

export default myAxios;
